import { Typography } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const ContainerAddress = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
`;

export const ContainerProducts = styled.div`
  margin-top: 20px;
`;

export const ContainerFormOfPayment = styled.div`
  margin-top: 20px;
`;

export const Grid = styled.div`
  display: flex;
  gap: 5px;
`;

export const ContainerText = styled.div`
  display: flex;
  margin-top: -3px;
  flex-direction: column;
  h6 {
    display: flex;
    white-space: nowrap;
  }
`;

export const CardProducts = styled.div`
  background: #fafafa;
  margin-top: 4px;
`;

export const ContainerProductsTitle = styled.div<{ isColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: ${({ isColor }) => isColor ?? "initial"};
`;

export const ContainerSelected = styled.div`
  display: flex;
  width: 300px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  padding-bottom: 35px;
  justify-content: space-between;
  padding: 0 50px;
  gap: 20px;
`;

export const TextPhone = styled(Typography)`
  display: flex;
  gap: 5px;
`;

export const ContainerProhone = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

export const ContainerFlags = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  gap: 8px;
`;

export const GasDoPovoTag = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 143px;
  height: 36px;
  padding: 6px 12px;
  background-color: #197396;
  color: #ffffff;
  border-radius: 16px;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.125;
`;

export const ContainerAdress = styled.div<{ shouldDisableBorder?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-bottom: 10px;

  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: ${({ shouldDisableBorder = false }) =>
    shouldDisableBorder ? "0" : "1px"};
`;

export const ButtonAcceptOrder = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px auto;
  background: #d33100;
  height: 42px;
  border-radius: 21px;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff;
  white-space: nowrap;
`;

export const ButtonRecuseOrder = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  background: none;
  height: 42px;
  border-radius: 21px;
  border: solid 1px #9847f5;
  cursor: pointer;
  color: #9847f5;
  white-space: nowrap;
`;

export const ButtonMap = styled.button`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
  gap: 6px;
`;

export const ButtonChat = styled.button`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
  gap: 6px;
`;

export const Link = styled.a`
  display: flex;
  text-decoration: none;
  color: rgba(0, 0, 0, 05);
  white-space: nowrap;
`;

export const ContainerDocumentFiscal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
`;

export const TitleMoreInfo = styled(Typography)`
  display: flex;
  padding-top: 12px;
`;

export const ContainerComplement = styled.div`
  width: 100%;
  margin-top: 7px;
  display: flex;
  gap: 10px;
  height: 20px;
  align-items: center;
  p {
    margin-top: -3px;
  }
`;

export const ContentDetails = styled.div<{
  currentTab?: boolean;
  fullHeight?: boolean;
}>`
  display: relative;
  overflow-y: auto;
  width: 100%;
  padding: 50px 30px 30px 30px;
  height: ${({ currentTab, fullHeight }) => {
    if (fullHeight && currentTab) {
      return "calc(100vh - 20px)";
    }

    if (fullHeight && !currentTab) {
      return "90vh";
    }

    if (currentTab) {
      return "calc(100vh - 230px)";
    }
    return "calc(100vh - 285px)";
  }};
`;

export const ContainerHours = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  text-align: center;
  div {
    margin-top: 0 !important;
  }
`;

export const ContainerDiscounts = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ContainerCupom = styled.div`
  display: flex;
  background: #ffca28;
  border-radius: 4px;
  padding: 4px 8px;
`;

export const ContainerRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonCopy = styled.button`
  display: flex;
  background: rgba(0, 0, 0, 0.04);
  border: none;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  cursor: pointer;
`;

export const TitleCopy = styled(Typography)`
  display: flex;
  color: #000000;
  text-decoration: underline;
`;

export const ContentCopy = styled.div`
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -555;
`;

export const ContainerRowsProducts = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 5px;
`;

export const ContainerStatus = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px 11px;
  gap: 5px;
  margin-left: 10px;
  background: green;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
`;

export const TitleStatus = styled(Typography)`
  display: flex;
  flex-direction: row;
  width: 170px;
  white-space: nowrap;
  align-items: center;
`;

export const ContainerPlaceOrigin = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ContentPlaceOrigin = styled.div`
  display: flex;
  background: #d331004d;
  height: 20px;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 12px;
  align-items: center;
`;

export const ContainerReasonHeader = styled.button`
  display: flex;
  align-items: center;
  height: 44px;
  margin-top: -32px;
  margin-left: -30px;
  margin-right: -30px;
  background: #dbab00;
  border: 0;
  gap: 10px;
  cursor: pointer;
  justify-content: center;
`;

export const ScheduledDeliveryOrder = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const ScheculedOrderCardTime = styled.div`
  width: fit-content;
  background: #fbefeb;
  padding: 8px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
